<!--
 * @Author: your name
 * @Date: 2021-08-05 16:52:04
 * @LastEditTime: 2022-01-11 17:34:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Basic\src\client\pages\CouponDetail.vue
-->
<template>
  <div class="message-fullscreen">
    <div class="message-content" v-html="activity.flag"></div>
  </div>
</template>

<script>
export default {
  name: "ActivityMessage",
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    activity() {
      return this.$store.getters.activity;
    },
    checkin() {
      return this.$store.getters.checkin;
    }
  },
  created() {
    // 浏览页面
    window.setTimeout(() => {
      this.$store.dispatch("onUserLogSend", {
        pageName: "信息提示页",
        behavior: { visist: "信息提示页" }
      });
    }, 500);
  }
};
</script>
